
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { inject, Injectable } from '@angular/core';
import { CorporateOnboardingRecordDto, CorporateOnboardingRecordsParameters, PagedResultDto } from '../../models';
import { HttpHelper } from '@umss/shared/utils';

@Injectable({
    providedIn: "root"
})
export class CorporateOnboardingRecordsService {    

  private readonly baseUrl = "/api/Corporate";
  private readonly http = inject(HttpClient);

	getAll(corporationId: string): Observable<CorporateOnboardingRecordDto[]> {
		return this.http.get<CorporateOnboardingRecordDto[]>(`${this.baseUrl}/${corporationId}/onboarding-records`);
	}

	getAllSearch(parameters?: CorporateOnboardingRecordsParameters): Observable<PagedResultDto<CorporateOnboardingRecordDto>> {
		const params = HttpHelper.toHttpParams(parameters ?? {});
		return this.http.get<PagedResultDto<CorporateOnboardingRecordDto>>(`${this.baseUrl}/onboarding-records/search`, { params });
	}

}